import { CustomerGroup, PrintCopyType } from "../../../types/customer.type";
import { COPY_TYPES } from "../../Customer/Details/printCopyTypes";

export const customerGroupLabel = (group: CustomerGroup): string =>
  `${group.code} · ${group.name} (${group.prefix})`;

export const isSameCustomerGroup = (first: CustomerGroup, second: CustomerGroup): boolean =>
  first.uuid === second.uuid;

/**
 * The groups the general-group setting may point at: those sharing the prefix of the group it
 * points at now, since the server accepts the general prefix only. Every group when the current
 * one is no longer listed, so MASTER can still repair the setting.
 */
export const generalGroupCandidates = (
  groups: CustomerGroup[],
  currentCode: string,
): CustomerGroup[] => {
  const currentPrefix = groups.find((group) => group.code === currentCode)?.prefix;
  return currentPrefix === undefined
    ? groups
    : groups.filter((group) => group.prefix === currentPrefix);
};

/** Adds or removes one copy type, keeping the A→D order the printer prints in. */
export const togglePrintCopy = (
  selected: PrintCopyType[],
  copyType: PrintCopyType,
): PrintCopyType[] => {
  const next = selected.includes(copyType)
    ? selected.filter((type) => type !== copyType)
    : [...selected, copyType];
  return COPY_TYPES.map((copy) => copy.key).filter((type) => next.includes(type));
};
